import { render, staticRenderFns } from "./VehiclesGallery.vue?vue&type=template&id=48b596dc"
import script from "./VehiclesGallery.vue?vue&type=script&lang=js"
export * from "./VehiclesGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports